import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationCircle,
  faArrowRight,
  faChevronLeft,
  faChevronRight,
  faAt,
  faKey,
  faChartLine,
  faStore,
  faCoins,
  faTags,
  faCog,
  faEuroSign,
  faArrowUp,
  faArrowDown,
  faPhone,
  faDirections,
  faQrcode,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faExclamationCircle);
library.add(faArrowRight);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faAt);
library.add(faKey);
library.add(faChartLine);
library.add(faStore);
library.add(faCoins);
library.add(faTags);
library.add(faCog);
library.add(faEuroSign);
library.add(faArrowUp);
library.add(faArrowDown);
library.add(faPhone);
library.add(faDirections);
library.add(faQrcode);
library.add(faTimes);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
